import { createBrowserRouter, redirect } from "react-router-dom";
import MarketingLayout from "./components/MarketingLayout";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Landing from "./pages/Landing";
import Explore, { exploreLoader } from "./pages/Explore";
import TourTemplate, { templateLoader } from "./pages/TourTemplate";
import FAQ from "./pages/FAQ";
import RouteError from "./pages/RouteError";
import GuidesIndex from "./pages/GuidesIndex";
import PackingGuideEurope from "./pages/PackingGuideEurope";
import PackingGuideCycling from "./pages/PackingGuideCycling";
import PowerPlugsGuide from "./pages/PowerPlugsGuide";
import FrenchTollRoadsGuide from "./pages/FrenchTollRoadsGuide";
import BikeSecurityGuide from "./pages/BikeSecurityGuide";
import GrandTourAlps2026 from "./pages/GrandTourAlps2026";
import FuelPrices, { fuelPricesLoader } from "./pages/FuelPrices";
import MotorbikeNavigationGuide from "./pages/MotorbikeNavigationGuide";
import CycleNavigationGuide from "./pages/CycleNavigationGuide";
import MotorbikeToolKitGuide from "./pages/MotorbikeToolKitGuide";
import MotorbikePunctureGuide from "./pages/MotorbikePunctureGuide";
import EuropeTripCostGuide from "./pages/EuropeTripCostGuide";
import ChannelCrossingGuide from "./pages/ChannelCrossingGuide";

// Public marketing site router. Everything served from this site is
// anonymous, indexable, and can be reached without an auth token. Any
// app/feature paths that arrive here (legacy bookmarks like /tours,
// /profile) should be handled by Amplify rewrites pointing them at
// app.planamoto.com — not by routes in this config.
//
// All real pages render inside <MarketingLayout /> so the header and
// footer are defined in exactly one place.

const router = createBrowserRouter([
    {
        element: <MarketingLayout />,
        errorElement: <RouteError />,
        children: [
            // The homepage lives at the root "/" so it's the canonical,
            // indexable URL. /landing is the legacy path and 301s here.
            { index: true, element: <Landing /> },
            { path: "/landing", loader: () => redirect("/") },
            { path: "/terms", element: <Terms /> },
            { path: "/privacy", element: <Privacy /> },
            { path: "/faq", element: <FAQ /> },
            { path: "/guides", element: <GuidesIndex /> },
            { path: "/guides/packing-europe", element: <PackingGuideEurope /> },
            { path: "/guides/cycle-touring-packing", element: <PackingGuideCycling /> },
            { path: "/guides/power-plugs", element: <PowerPlugsGuide /> },
            { path: "/guides/french-toll-roads", element: <FrenchTollRoadsGuide /> },
            { path: "/guides/bike-security", element: <BikeSecurityGuide /> },
            { path: "/guides/grand-tour-europe", element: <GrandTourAlps2026 /> },
            { path: "/guides/fuel-prices", element: <FuelPrices />, loader: fuelPricesLoader },
            { path: "/guides/motorbike-navigation-tools", element: <MotorbikeNavigationGuide /> },
            { path: "/guides/cycle-navigation-tools", element: <CycleNavigationGuide /> },
            { path: "/guides/motorbike-tool-kit", element: <MotorbikeToolKitGuide /> },
            { path: "/guides/motorbike-puncture-repair", element: <MotorbikePunctureGuide /> },
            { path: "/guides/europe-trip-cost", element: <EuropeTripCostGuide /> },
            { path: "/guides/channel-crossings", element: <ChannelCrossingGuide /> },
            { path: "/explore", element: <Explore />, loader: exploreLoader },
            { path: "/explore/:slug", element: <TourTemplate />, loader: templateLoader },
        ],
    },
]);

export default router;
